<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'transactions'" [businessName]="vm.businessName" [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>

<div class="container" *ngIf="!vm.isOpening">
    <div class="row pt-4 ">
        <div class="col-md-6 section-header">Add Water Usage</div>
</div>
<div>
    <hr class="mt-0 mb-1" />
</div>
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <form>
         <div>

          <div class="row">
            <div class="col">
              <label>Vehicle *</label>
              <select class="form-control" name="vehicles" [(ngModel)]="vm.vehicleId"
              (change)="calculateCost()" [ngClass]="{'is-invalid': !!error('vehicleId')}">
                <option [value]=""></option>
                <option *ngFor="let c of vm.vehicles" [value]="c.vehicleId">
                  {{c.description}}
                </option>
              </select>
              <div class="invalid-feedback"> {{error('vehicleId')}} </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>Suburb *</label>
              <input class="form-control" [ngClass]="{'is-invalid': !!error('suburb')}" name="suburb" placeholder=""
                type="text" [(ngModel)]="vm.suburb">
              <div class="invalid-feedback"> {{error('suburb')}} </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <label>Date *</label>
              <input class="form-control" [ngClass]="{'is-invalid': !!error('fillDate')}" name="fillDate"
                placeholder="dd/mm/yyyy" type="text" ngbDatepicker [(ngModel)]="vm.fillDate" #dfillDate="ngbDatepicker"
                (click)="dfillDate.toggle()" [maxDate]="vm.maxDate">
              <div class="invalid-feedback"> {{error('fillDate')}} </div>
            </div>

            <div class="col-6">
              <label>Time </label>
              <select class="form-control" name="fillTime" [(ngModel)]="vm.fillTime"
              [ngClass]="{'is-invalid': !!error('fillTime')}">
                <option [value]=""></option>
                <option *ngFor="let c of vm.times" [value]="c.timeId">
                  {{c.description}}
                </option>
              </select>
              <div class="invalid-feedback"> {{error('fillTime')}} </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label>Comment</label>
              <input class="form-control" [ngClass]="{'is-invalid': !!error('comment')}" name="comment" placeholder=""
                type="text" [(ngModel)]="vm.comment">
              <div class="invalid-feedback"> {{error('comment')}} </div>
            </div>
          </div>

          <div class="row">

            <div class="col-6">
              <label>Price per kL</label>
              <h6 class="font-weight-bold">{{vm.usageRate  | currency:false:'symbol':'0.4'}}</h6>
            </div>

            <div class="col-6">
              <label>Capacity</label>
              <h6 class="font-weight-bold">{{vm.usage}}</h6>
            </div>


          </div>

          <div class="row">
            <div class="col-6">
              <label>Total Cost</label>
              <h6 class="font-weight-bold">{{vm.usageCost  | currency:false:'symbol':'0.4'}}</h6>
            </div>

            <div class="col-6">
            </div>

          </div>

        </div>
        <div>
            <hr class="mt-0 mb-1" />
        </div>
        <div class="d-flex justify-content-end">
          <div><button type="button" class="btn btn-primary" (click)="proceedYes()">OK</button></div>
          <div><button type="button" class="btn btn-link" (click)="proceedCancel()">Cancel</button></div>
        </div>
      </form>
    </div>
  </div>
</div>
